// extracted by mini-css-extract-plugin
export default {"container":"plain-board_container__JzxiQ","hooks":"plain-board_hooks__m507E","hook-anchors":"plain-board_hook-anchors__f3iQd"};